module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nofind"
  }, [_c('h3', [_vm._v("很抱歉，没有找到该页面...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32a23743"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nofind.vue
// module id = 43
// module chunks = 0